import React from 'react';
import PropTypes from 'prop-types';
import OperatorLogoSrc from '../../../asset/svg/guidewireLogo.svg';
import HeaderNav from './navigation/headerNav';
import {Avatar, Button} from '@elixir/components';
import UserProfileMenu from './userProfileMenu/userProfileMenu';
import './header.scss';

export default class HeaderContainer extends React.Component {

    constructor (props) {
        super(props);
    }

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    render () {

        return (
            <div className="header">

                <img src={OperatorLogoSrc} className="operatorLogo"/>

                <HeaderNav/>

                <Button className="helpButton"
                        name="helpButton"
                        type="tertiary"
                        size="small"
                        icon="fa-question-circle"
                        disabled={true}>
                </Button>

                <Button className="settingButton"
                        name="settingButton"
                        type="tertiary"
                        size="small"
                        icon="fa-cog"
                        disabled={true}>
                </Button>

                <UserProfileMenu/>

            </div>
        );
    }
}

